import { IInvoice, IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import uniq from "lodash/uniq";
import { useMemo } from "react";
import { useQueryInvoicesByIds } from "../../../query/invoices/queries/useQueryInvoicesByIds";

export const useInvoicesMap = (workLogs: IWorkLog[] | undefined) => {
  const invoiceIds = useMemo(
    () =>
      uniq(
        (workLogs || [])
          .map(workLog => workLog.invoiceId)
          .filter((id): id is string => !!id)
      ),
    [workLogs]
  );

  const queryInvoices = useQueryInvoicesByIds(invoiceIds, {
    enabled: invoiceIds.length > 0
  });

  const invoicesMap = useMemo(() => {
    const map = new Map<string, IInvoice>();
    (queryInvoices.data || []).forEach(invoice => {
      map.set(invoice.invoiceId, invoice);
    });
    return map;
  }, [queryInvoices.data]);

  return {
    invoicesMap,
    isLoading: queryInvoices.isLoading && invoiceIds.length > 0
  };
};
